import React, { ReactNode } from "react";

import {
  Button,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from "@origin-digital/ods-core";

interface IProps {
  "data-id": string;
  label: string;
  actionId?: string;
  linkText?: string;
  onClick?(): void;
  value?: string | string[];
  children?: ReactNode;
}

export const getItems = (value?: string | string[]): string[] => {
  if (!value || !value.length) {
    return [""];
  }

  if (typeof value === "string") {
    return [value];
  }

  return value;
};

export const Description: React.FC<IProps> = ({
  children,
  "data-id": dataId,
  label,
  actionId,
  linkText,
  onClick,
  value,
}) => (
  <Stack data-id={dataId} space="xsmall">
    <Text data-id="label" variant="body-small" tone="neutralLight">
      {label}
    </Text>
    <Columns alignY="center">
      <Column>
        {getItems(value).map((text) => (
          <Text key={text} data-id="value" truncate>
            {/* We need to fallback to non breaking space so the the correct spacing is displayed */}
            {text || "\u00a0"}
          </Text>
        ))}
      </Column>
      {linkText && onClick ? (
        <Column width="content" alignX="right">
          <Button
            id={actionId}
            data-id={`button-${dataId}`}
            noTextPadding
            onClick={(e) => {
              e.preventDefault();
              onClick();
            }}
            size="small"
            variant="text"
          >
            {linkText}
          </Button>
        </Column>
      ) : null}
    </Columns>
    {children}
  </Stack>
);

export const DescriptionList: React.FC<{
  heading: string;
  "data-id": string;
  children?: ReactNode;
}> = ({ children, "data-id": dataId, heading }) => (
  <Stack data-id={dataId}>
    <Heading variant="h3">{heading}</Heading>
    <Stack space={["medium", "large"]}>{children}</Stack>
  </Stack>
);
